module.exports = __webpack_public_path__ + "static/media/yubikey.d716b4c8.svg";